import styled from 'styled-components';

const NoResultContainer = styled.div`
  margin-top: 20px;
  text-align: center;
  width: 100%;
`;

export { NoResultContainer };
